'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _GlobalApi = require('@/libs/GlobalApi');

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _Misc = require('@/helpers/Misc');

var _App = require('@/components/App');

var _App2 = _interopRequireDefault(_App);

var _Container = require('@/customized-core/Container.vue');

var _Container2 = _interopRequireDefault(_Container);

var _Welcome = require('@/customized-core/startups/Welcome.vue');

var _Welcome2 = _interopRequireDefault(_Welcome);

var _DataFlow = require('@/helpers/DataFlow');

var _DataFlow2 = _interopRequireDefault(_DataFlow);

var _mobileDeviceDetect = require('mobile-device-detect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	mixins: [_App2.default],
	components: {
		Container: _Container2.default,
		StartupWelcome: _Welcome2.default
	},
	clientThemes: {
		test: 'Sky',
		isexychat: 'Magenta'
	},
	computed: {
		style: function style() {
			var newSize = 55;
			if (this.initialVisualViewportHeight && this.currentVisualViewportHeight) {
				newSize = Math.floor(100 * this.currentVisualViewportHeight / this.initialVisualViewportHeight);
			}

			return {
				height: this.$state.isIos && this.isKeyboardOpened ? newSize + '%' : '100%'
			};
		},
		adsSlots: function adsSlots() {
			return this.$state.adsSlots;
		}
	},
	watch: {
		adsSlots: function adsSlots(value) {
			(0, _Misc.activateAdsSlots)(value, this.$state.adsTags);
		}
	},
	mounted: function mounted() {
		var startupScreens = {
			welcome: _Welcome2.default
		};
		var extraStartupScreens = this.$state.getStartups();

		var startupName = this.$state.settings.startupScreen || 'personal';
		var startup = extraStartupScreens[startupName] || startupScreens[startupName];

		if (!startup) {
			Logger.error('Startup screen "' + startupName + '" does not exist');
		} else {
			this.startupComponent = startup;
		}
		this.trackWindowDimensions();

		this.$state.isIos = _mobileDeviceDetect.isIOS;
		this.$state.isAndroid = _mobileDeviceDetect.isAndroid;
		this.$state.isMobile = _mobileDeviceDetect.isMobile;
		this.$state.isTablet = _mobileDeviceDetect.isTablet;

		var self = this;
		if (window.visualViewport) {
			this.initialVisualViewportHeight = window.visualViewport.height;
			window.visualViewport.addEventListener('resize', function (event) {
				self.currentVisualViewportHeight = event.target.height;
				self.isKeyboardOpened = event.target.height < self.initialVisualViewportHeight;
			});
		}
		window.addEventListener('scroll', function (e) {
			if (self.$state.isIos && this.isKeyboardOpened) {
				window.scrollTo(0, window.scrollHeight);
				self.isNeededMessagesScroll = true;
			}
		});
	},
	beforeCreate: function beforeCreate() {
		var queryClient = (0, _Misc.queryStringVal)('client');
		var clientTheme = this.$options.clientThemes[queryClient] || 'Magenta';

		_GlobalApi2.default.singleton().themes.setTheme(clientTheme);
	},
	created: function created() {
		var queryServer = (0, _Misc.queryStringVal)('server');
		var queryPort = (0, _Misc.queryStringVal)('port');

		if (queryServer) {
			this.$state.settings.startupOptions.server = queryServer;
		}

		if (queryPort) {
			this.$state.settings.startupOptions.port = queryPort;
		}
		this.initDataFlow();
		this.storeAdsTags();
	},
	updated: function updated() {
		if (this.$state.isIos && this.isKeyboardOpened) {
			window.scrollTo(0, window.scrollHeight);
		}
		this.isNeededMessagesScroll = false;
	},


	methods: {
		initDataFlow: function initDataFlow() {
			var firestore = (0, _Misc.queryStringVal)('firestore');
			var dataFlowOptions = this.$state.settings.dataFlowOptions;
			var firestoreServers = dataFlowOptions.firestoreServers;
			var firestoreOptions = firestore && firestoreServers.hasOwnProperty(firestore) ? firestoreServers[firestore] : firestoreServers[dataFlowOptions.defaultFirestoreServer];
			this.$state.dataFlow = new _DataFlow2.default(firestoreOptions);
		},
		storeAdsTags: function storeAdsTags() {
			var queryParams = (0, _Misc.queryStringAllParameters)();
			var adsParamPrefix = /^x-utm_/;
			var removablePrefix = /^x-(.*)/;
			var adsTags = {};
			(0, _keys2.default)(queryParams).forEach(function (key) {
				if (adsParamPrefix.test(key)) {
					var found = key.match(removablePrefix);
					if (found.length > 1) {
						adsTags[found[1]] = queryParams[key];
					}
				}
			});

			this.$state.adsTags = adsTags;
		}
	}

};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/App.vue
// module id = L1mr
// module chunks = 1